/**
 * File: productsDropDown.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v3.0.5
 * Created: 2025-12-04
 * Last Updated: 2026-06-22
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Local project files
import { routes } from "../../constants/routes";

// Products Dropdown
export const productsDropDown = {
    id: "products-dropdown",
    label: "PRODUCTS",
    featureText: "Browse by product",
    features: [
        {
            id: "feature-pdd-1",
            link: routes.public.products.root,
            image: "../svgs/dropdown_products_tecthub-icon.svg",
            header: "TECTHUB",
            description:
                "On-demand engineering support for drafting, design, and QAQC.",
        },
        {
            id: "feature-pdd-2",
            link: routes.public.products.root,
            image: "../svgs/dropdown_products_flowkit-icon.svg",
            header: "FLOWKIT",
            description:
                "HVAC and plumbing calculation tools for fast, accurate design.",
        },
        {
            id: "feature-pdd-3",
            link: routes.public.products.root,
            image: "../svgs/dropdown_products_nameplate-icon.svg",
            header: "NAMEPLATE",
            description:
                "Generate clean, accurate equipment schedules in seconds.",
        },
        {
            id: "feature-pdd-4",
            link: routes.public.products.root,
            image: "../svgs/dropdown_products_isocheck-icon.svg",
            header: "ISOCHECK",
            description:
                "Automated QA/QC review tools to improve design accuracy.",
        },
    ],
    actionImage: "./svgs/dropdown_products_block-buildings.svg",
    actionHeader: "Tools Built for Modern MEP Teams",
    actionDescription:
        "Purpose-built software to accelerate mechanical and plumbing workflows.",
    actionButtonText: "Browse all products",
    actionButtonLink: routes.public.products.root,
};
